import { claimsApiService } from '@/services/claims-api.service'
import { custPaymentsService } from "@/services/custpayments-api.service";

const SET_ITEMS = 'setItems'
const SET_REJECTED_ITEMS = 'setRejectedItems'
const UPDATE_ITEM = 'updateItem'
const SET_PIPELINE_HISTORY = 'setPipelineHistory'
const SET_EXPORT_FILES = 'setExportFiles'
const INSERT_EXPORT_FILES = 'addExportFiles'
const SET_REJECT_REASONS = 'setRejectReasons'

const state = () => ({
    items: [],
    rejectedItems: [],
    pipelineHistory: {},
    exportFiles: [],
    rejectReasons: []
});

const getters = {
    getItems: state => state.items,
    getRejectedItems: state => state.rejectedItems,
    getPipelineHistoryItems: state => state.pipelineHistory,
    getExportFiles: state => state.exportFiles,
    getRejectReasons: state => state.rejectReasons
};

const mutations = {
    [SET_REJECTED_ITEMS](state, payload) {
        state.rejectedItems = [...payload]
    },
    [SET_ITEMS](state, payload) {
        state.items = payload
    },
    [UPDATE_ITEM](state, item) {
        state.items = [
            ...state.items.filter(itm => itm.id != item.id),
            item
        ]
    },
    [SET_PIPELINE_HISTORY](state, payload) {
        state.pipelineHistory = payload
    },
    [SET_EXPORT_FILES](state, payload) {
        state.exportFiles = payload
    },
    [INSERT_EXPORT_FILES](state, item) {
        state.exportFiles = [
            ...state.exportFiles.filter(itm => itm.id != item.id),
            item
        ]
    },
    [SET_REJECT_REASONS](state, payload) {
        state.rejectReasons = payload
    }
};

const actions = {
    getItems({ commit }, payload) {
        return new Promise((resolve, reject) => {
            custPaymentsService
                .getItems()
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_ITEMS, apiResponse.data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getItemsRemote({ commit }, payload) {
        return new Promise((resolve, reject) => {
            custPaymentsService
                .getItemsRemote()
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_ITEMS, apiResponse.data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getRejectedItems({ commit }, payload) {
        return new Promise((resolve, reject) => {
            custPaymentsService
                .getRejectedItems()
                .then(response => {
                    let { data: apiResponse } = response
                    console.log("-r: ", response)
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_REJECTED_ITEMS, apiResponse.data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    setStatus({ commit }, payload) {
        console.log('-sp: ', payload)
        return new Promise((resolve, reject) => {
            custPaymentsService
                .setStatus(payload)
                .then(response => {
                    console.log('-r: ', response)
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            console.log('-d: ', apiResponse.data)
                            commit(UPDATE_ITEM, apiResponse.data)
                        }
                    }
                    resolve(apiResponse.data);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getPipelineRunHistory({ commit }, payload) {
        return new Promise((resolve, reject) => {
            claimsApiService
                .getPipelineRunHistoryForClaim(payload)
                .then((response) => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_PIPELINE_HISTORY, apiResponse.data)
                        }
                    }
                    resolve(apiResponse)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally()
        })
    },
    resetPipelineRunHistory({ commit }) {
        commit(SET_PIPELINE_HISTORY, {})
    },
    getExportFiles({ commit }, payload) {
        return new Promise((resolve, reject) => {
            custPaymentsService
                .getExportFiles()
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_EXPORT_FILES, apiResponse.data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    async getExportRows({ commit }, payload) {
        return new Promise((resolve, reject) => {
            custPaymentsService
                .getExportRows(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    //if (response.status == 200) {
                    //    if (apiResponse) {
                    //        commit(SET_EXPORT_FILES, apiResponse.data)
                    //    }
                    //}
                    resolve(apiResponse.data);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    scheduleExport({ commit }, payload) {
        return new Promise((resolve, reject) => {
            custPaymentsService
                .scheduleExport(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(INSERT_EXPORT_FILES, apiResponse.data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getRejectReasons({ commit }, payload) {
        return new Promise((resolve, reject) => {
            custPaymentsService
                .getRejectReasons()
                .then(response => {
                    console.log('-r: ', response)
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_REJECT_REASONS, apiResponse)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getStatusHistory({ commit }, payload) {
        return new Promise((resolve, reject) => {
            custPaymentsService
                .getStatusHistory(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            //commit(SET_REJECT_REASONS, apiResponse)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}